import { render, staticRenderFns } from "./taskInstance.vue?vue&type=template&id=19a2cb34&"
import script from "./taskInstance.vue?vue&type=script&lang=js&"
export * from "./taskInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports